import React from "react";
import {inject, observer} from "mobx-react";
import {useTranslation} from "react-i18next";
import {ButtonTransparent} from "../../../buttons/ButtonTransparent";

export const Logout = inject("store")(
  observer(({store: {auth}}) => {
    const {t} = useTranslation();

    return (
      <div className="settings-account_logout__wrapper">
        <h4 className="__uppercase">{t("LOGOUT_LOG_OUT_OF_HANDYDAY")}?</h4>
        <p>{t("LOGOUT_OF_HANDYDAY_DESCRIPTION")}</p>
        <ButtonTransparent
          name={t("LOGOUT_LOG_OUT_OF_HANDYDAY")}
          loading={auth.logoutLoading}
          onClick={() => auth.logout()}
          addClass="__danger"
        />
      </div>
    );
  })
);
